import { useMemo } from 'react';
import { useGetBusinessProfilesHandler } from '../../../dataHandlers/getBusinessProfilesHandler';
import { Box } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import BusinessProfileTableStatusChip from './BusinessProfilesTableStatusChip';

const OverviewTable = ({ selectedFilter, searchTerm }) => {
  const { profiles, isLoading } = useGetBusinessProfilesHandler({});

  const filteredProfiles = useMemo(() => {
    const term = searchTerm?.trim().toLowerCase();
    if (!term) return profiles;

    return profiles.filter((row) =>
      String(row?.[selectedFilter] ?? '')
        .toLowerCase()
        .includes(term),
    );
  }, [profiles, selectedFilter, searchTerm]);

  const columns = [
    {
      headerName: 'Account Email',
      field: 'account_email',
      flex: 0.75,
      valueGetter: (value, row) => {
        return row?.org_email;
      },
    },
    {
      headerName: 'TIN Status',
      field: 'tin_status',
      flex: 0.6,
      valueGetter: (value, row) => {
        return row?.status;
      },
      renderCell: (params) => {
        return <BusinessProfileTableStatusChip status={params?.row?.status} />;
      },
    },
    {
      headerName: 'TIN',
      field: 'tin',
      flex: 0.6,
      valueGetter: (value, row) => {
        return row?.tin;
      },
    },
    {
      headerName: 'Emaratax Email',
      field: 'emaratax_email',
      flex: 1,
      valueGetter: (value, row) => {
        return row?.email;
      },
    },
  ];

  return (
    <Box>
      <DataGrid
        rows={filteredProfiles}
        columns={columns}
        getRowId={(row) => row.tin}
        loading={isLoading}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 10,
            },
          },
        }}
        pageSizeOptions={[10, 25]}
        disableRowSelectionOnClick
      />
    </Box>
  );
};

export default OverviewTable;
